import { GlobalState } from '../../actions';
import { ServerType } from '../../System/systemConfig';

export const eventHandlerConfigSelector = (state: GlobalState) => state.eventHandlerConfig;

export const eventHandlerConfigEntitySelector = (server: ServerType) => (state: GlobalState) =>
    eventHandlerConfigSelector(state)[server] ? eventHandlerConfigSelector(state)[server].handler : undefined;

export const eventHandlerConfigMissingSelector = (server: ServerType) => (state: GlobalState) =>
    eventHandlerConfigSelector(state)[server] ? eventHandlerConfigSelector(state)[server].missing : undefined;
